import { useMutation } from 'react-query';

import { changeCardLane as mutationFn } from 'api/endPoints/changeCardLane';

export const useMutationUpdateCardLaneIdData = () => {
    return useMutation<string, QueryError, IUpdateCardLaneIdDataPayload>((params) => mutationFn(params));
};

interface IUpdateCardLaneIdDataPayload {
    id: string;
    laneId?: string;
    isVirtual: boolean;
    versionId: number;
}
